export const PROMOTION_2025_04_MANDARAKE = {
  SCHEDULE: {
    START_DATE: process.env.NEXT_PUBLIC_ENV === 'production' ? '2025-04-08:09:00:00' : '2025-03-26:09:00:00',
    END_DATE: '2025-04-25:23:59:59',
  },
  EXHIBITION_URL:
    process.env.NEXT_PUBLIC_ENV === 'production'
      ? 'https://exhibition.bunjang.co.kr/viewer/mandarake_2504'
      : 'https://exhibition.bunjang.co.kr/viewer/mandarake_2504',
};

export const PROMOTION_2025_04_KAKAO = {
  SCHEDULE: {
    START_DATE: '2025-04-01:09:00:00',
    END_DATE: '2025-04-30:23:59:59',
  },
  EXHIBITION_URL: 'https://exhibition.bunjang.co.kr/viewer/mercari_kakaopaypromo_2504',
};

export const PROMOTION_2025_05_06_RAGTAG = {
  SCHEDULE: {
    START_DATE: process.env.NEXT_PUBLIC_ENV === 'production' ? '2025-05-30:09:00:00' : '2025-05-20:09:00:00',
    END_DATE: '2025-06-15:23:59:59',
  },
  EXHIBITION_URL: 'https://exhibition.bunjang.co.kr/viewer/mercari_ragtag_2505',
};

export const PROMOTION_2025_06_FIRST_PURCHASE = {
  SCHEDULE: {
    START_DATE: '2025-06-19:09:00:00',
    END_DATE: '2025-06-30:23:59:59',
  },
  EXHIBITION_URL: 'https://exhibition.bunjang.co.kr/viewer/mercari_first_buy_coupon',
};

export const PROMOTION_2025_07_FIRST_PURCHASE = {
  SCHEDULE: {
    START_DATE: process.env.NEXT_PUBLIC_ENV === 'production' ? '2025-07-10:09:00:00' : '2025-07-09:09:00:00',
    END_DATE: '2025-07-31:23:59:59',
  },
  EXHIBITION_URL: 'https://exhibition.bunjang.co.kr/viewer/mercari_first_buy_coupon_july',
};

export const PROMOTION_2025_08_09 = {
  SCHEDULE: {
    START_DATE: process.env.NEXT_PUBLIC_ENV === 'production' ? '2025-08-13:09:00:00' : '2025-08-08:09:00:00',
    END_DATE: '2025-09-30:23:59:59',
  },
  EXHIBITION_URL:
    process.env.NEXT_PUBLIC_ENV === 'production'
      ? 'https://exhibition.bunjang.co.kr/viewer/mercari_first_buy_coupon_august'
      : 'https://exhibition.stg-bunjang.co.kr/viewer/mercari_stg_coupon',
};

export const PROMOTION_2026_03 = {
  SCHEDULE: {
    START_DATE: '2026-03-09:08:00:00',
    END_DATE: '2026-03-30:23:59:59',
  },
  EXHIBITION_URL: 'https://exhibition.bunjang.co.kr/viewer/mercari_promotion_2026_mar',
};
